module.exports = __webpack_public_path__ + "img/logo_new.425e4c37.png";